import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { initialValues } from './formData';
import { cleanObj } from '../../../../shared/utils/objects';
import { TenderFilter } from '../../../../shared/types/tender';
import { asyncGetParams } from '../../../../services/param.service';
import { ISelect, ParamEnum } from '../../../../shared/types/shared';

export const useTenderFilters = (onFilter?: (data: TenderFilter) => void) => {
    const [statusProcessOptions, setStatusProcessOptions] = useState<ISelect[]>(
        []
    );

    useEffect(() => {
        asyncGetParams(ParamEnum.STATUS_PROCESS).then(
            setStatusProcessOptions || []
        );
    }, []);

    const onSubmit = (data: TenderFilter) => {
        if (onFilter) onFilter(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues,
        onSubmit,
    });

    return {
        formik,
        statusProcessOptions,
    };
};
